/**
 * SLIDER JS
 *
 */
import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Slider
         */
        console.log( 'Sliders - init' );

    },
    
    sliderInit( target_slider ) {
        var slider = '#' + target_slider;
        Foundation.reInit( $( slider ) );
        console.log( 'slider: ' + slider ); 
    },
    
    sliderChange( target_slider ) {
        var slider = '#' + target_slider;
        $( 'body' ).on( 'slidechange.zf.orbit', slider, ( e, handle ) => { // Function defined using arrow method to gain access to main 'this'
            console.log ( 'slidechange' );
            this.getActiveSlideNumber( target_slider );
        });
    },
    
    getActiveSlideNumber( target_slider ) {
        var slider = '#' + target_slider;
        var slides = $( slider + ' .orbit-slide' );
        var totalSlides = slides.length;
        var activeSlide = slides.filter( '.is-active' );
        var activeNum = slides.index( activeSlide ) + 1;
        
        console.log( 'activeSlide: ' + activeSlide.css( 'height' ) );
        
        // Get height of active slide, set height of orbit-container to this height,
        // This deals with the issue of some slide contents being cropped off.
        $( slider + ' .orbit-container' ).css('height', activeSlide.css( 'height' ) );
        
        console.log( slider + ': activeNum: ' + activeNum );
        if (activeNum == 1 ) {
            $( slider + ' .orbit-previous' ).addClass( 'disabled' );
            $( slider + ' .orbit-next' ).removeClass( 'disabled' );
        } else if ( activeNum == totalSlides ) {
            $( slider + ' .orbit-previous' ).removeClass( 'disabled' );
            $( slider + ' .orbit-next' ).addClass( 'disabled' );
        } else {
            $( slider + ' .orbit-previous' ).removeClass( 'disabled' );
            $( slider + ' .orbit-next' ).removeClass( 'disabled' );
        }
        console.log( slider + ': totalSlides: ' + totalSlides );

    },
    
    sliderAddSlide( target_slider, slide_content, target_slide ) {
        var slider = '#' + target_slider;
        var content = slide_content;
        var slide = target_slide;
        $( slider + ' ' + slide ).after( content );
    }
  
}